import { useQuery } from '@tanstack/react-query'
import { ProjectService } from 'src/services/project.service'
import { TLabel } from 'src/types/locales'

export enum EPatientFollowupDocumentStatus {
  RECEIVED = 'RECEIVED',
  WAIVED = 'WAIVED',
  REQUESTED = 'REQUESTED',
  EXPECTED = 'EXPECTED',
}

export interface TPatientFollowupDocument {
  variableId: number
  variableName: string
  variableIntlLabel: TLabel | null
  status: EPatientFollowupDocumentStatus
  /** Form holding the received file, null for a standalone file. Only set when RECEIVED. */
  patientFormId: number | null
  /** When the file was received. Only set when RECEIVED. */
  receivedAt: string | null
  /** When the staff marked it as received. Only set when WAIVED. */
  waivedAt: string | null
  /** When the chatbot started waiting for it. Only set when REQUESTED. */
  requestedAt: string | null
}

const usePatientFollowupDocuments = (
  patientFollowupId: number,
  patientId: string | number,
  projectId: string | number,
) => {
  const { data, isLoading, isError, refetch } = useQuery<TPatientFollowupDocument[]>({
    queryKey: ['patient-followup-documents', projectId, patientId, patientFollowupId],
    queryFn: () => ProjectService.getPatientFollowupDocuments(patientFollowupId, patientId, projectId),
  })

  return { documents: data ?? [], isLoading, isError, refetch }
}

export { usePatientFollowupDocuments }
